var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTajikistan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.07906C0.5705 11.1826 0 13.5424 0 16.0356C0 18.5287 0.5705 20.8886 1.58763 22.9921L16 24.3834L30.4124 22.9921C31.4295 20.8886 32 18.5287 32 16.0356C32 13.5424 31.4295 11.1826 30.4124 9.07906L16 7.68774L1.58763 9.07906Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 22.9919C4.17607 28.3438 9.65664 32.0354 15.9999 32.0354C22.3433 32.0354 27.8239 28.3438 30.4118 22.9919H1.58813Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 9.07866H30.4118C27.8239 3.72678 22.3433 0.0351562 15.9999 0.0351562C9.65664 0.0351562 4.17607 3.72678 1.58813 9.07866Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 20.2092H18.783V17.844L17.67 18.4005L16.0004 16.7309L14.3308 18.4005L13.2178 17.844V20.2092Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0337 17.4258L10.2928 18.2229H11.1309L10.4528 18.7156L10.7118 19.5127L10.0337 19.0201L9.35559 19.5127L9.61465 18.7156L8.93652 18.2229H9.77465L10.0337 17.4258Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8372 14.6436L11.0962 15.4407H11.9344L11.2562 15.9334L11.5152 16.7306L10.8372 16.2379L10.1591 16.7306L10.4181 15.9334L9.73999 15.4407H10.5781L10.8372 14.6436Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1323 12.5563L13.3914 13.3534H14.2295L13.5515 13.8461L13.8104 14.6433L13.1323 14.1506L12.4543 14.6433L12.7133 13.8461L12.0352 13.3534H12.8733L13.1323 12.5563Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9675 17.4258L21.7085 18.2229H20.8704L21.5485 18.7156L21.2894 19.5127L21.9675 19.0201L22.6456 19.5127L22.3866 18.7156L23.0647 18.2229H22.2266L21.9675 17.4258Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1643 14.6436L20.9053 15.4407H20.0671L20.7453 15.9334L20.4862 16.7306L21.1643 16.2379L21.8425 16.7306L21.5834 15.9334L22.2615 15.4407H21.4234L21.1643 14.6436Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8679 12.5563L18.6088 13.3534H17.7708L18.4488 13.8461L18.1898 14.6433L18.8679 14.1506L19.5459 14.6433L19.2869 13.8461L19.965 13.3534H19.1269L18.8679 12.5563Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 11.513L16.2598 12.3101H17.0979L16.4198 12.8028L16.6789 13.5999L16.0008 13.1073L15.3226 13.5999L15.5817 12.8028L14.9036 12.3101H15.7417L16.0008 11.513Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/tajikistan.e5741b0c.svg";
export { ForwardRef as ReactComponent };